import React from 'react';


function AdminRegistration() {
    return (
        <div>
            <h2>AdminRegistration</h2>
            <p>Welcome to the AdminRegistration page!</p>
        </div>
    );
}

export default AdminRegistration;